import { __require as requirePostcss } from "../../../postcss@8.5.8/node_modules/postcss/lib/postcss2.js";
import { __require as requireParser } from "./parser.js";
import { __require as requireProcessResult } from "./process-result.js";
var async;
var hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync) return async;
  hasRequiredAsync = 1;
  let postcss = requirePostcss();
  let parse = requireParser();
  let processResult = requireProcessResult();
  async = function async2(plugins) {
    let processor = postcss(plugins);
    return async (input) => {
      let result = await processor.process(input, {
        parser: parse,
        from: void 0
      });
      return processResult(result);
    };
  };
  return async;
}
export {
  requireAsync as __require
};
//# sourceMappingURL=async.js.map
